import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import FeaturedEvents from '../components/FeaturedEvents';
import FeaturedResources from '../components/FeaturedResources';
import CodeTeam from '../components/CodeTeam';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import '../styles/Home.css';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <div className="home-page">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorks />
        <FeaturedEvents />
        <CodeTeam />
        <FeaturedResources />
        <Testimonials />
        <CTASection />
        <Footer />
      </main>
    </div>
  );
};

export default Home;
